// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"MenuEditNft_iconContainer__4WOKo"};